import {MNullable} from '../../Toolkit/Utils';

export class FileData {
    public id: string = '';
    public parentId: string = '';
    public fileType: number = 0;
    public fileStatus: number = 0;
    public fileFolder: number = 0;
    public note: string = '';
    public sendToCrew: boolean = false;
    public modifiedBy: string = '';
    public modifiedOn: MNullable<Date> = null;
};

export class FileReply {
    public file: MNullable<FileData> = null;
};

export class FileMultiReply {
    public files: FileData[] = [];
};